function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _wrapRegExp(re, groups) {
  _wrapRegExp = function _wrapRegExp(re, groups) {
    return new BabelRegExp(re, undefined, groups);
  };

  var _RegExp = _wrapNativeSuper(RegExp);

  var _super = RegExp.prototype;

  var _groups = new WeakMap();

  function BabelRegExp(re, flags, groups) {
    var _this = _RegExp.call(this, re, flags);

    _groups.set(_this, groups || _groups.get(re));

    return _this;
  }

  _inherits(BabelRegExp, _RegExp);

  BabelRegExp.prototype.exec = function (str) {
    var result = _super.exec.call(this, str);

    if (result) result.groups = buildGroups(result, this);
    return result;
  };

  BabelRegExp.prototype[Symbol.replace] = function (str, substitution) {
    if (typeof substitution === "string") {
      var groups = _groups.get(this);

      return _super[Symbol.replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function (_, name) {
        return "$" + groups[name];
      }));
    } else if (typeof substitution === "function") {
      var _this = this;

      return _super[Symbol.replace].call(this, str, function () {
        var args = [];
        args.push.apply(args, arguments);

        if (_typeof(args[args.length - 1]) !== "object") {
          args.push(buildGroups(args, _this));
        }

        return substitution.apply(this, args);
      });
    } else {
      return _super[Symbol.replace].call(this, str, substitution);
    }
  };

  function buildGroups(result, re) {
    var g = _groups.get(re);

    return Object.keys(g).reduce(function (groups, name) {
      groups[name] = result[g[name]];
      return groups;
    }, Object.create(null));
  }

  return _wrapRegExp.apply(this, arguments);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

import _ from 'underscore';
export var RGBA_REGEXP = /*#__PURE__*/_wrapRegExp(/^rgba[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]?\((?:[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]?,?([0-9]{1,3})[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]?,?)(?:[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]?,?([0-9]{1,3})[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]?,?)(?:[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]?,?([0-9]{1,3})[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]?,?)(?:[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]?,?([\.0-9]+)[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]?,?)\)$/i, {
  red: 1,
  green: 2,
  blue: 3,
  alpha: 4
});
export var RGB_REGEXP = /*#__PURE__*/_wrapRegExp(/^rgb[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]?\((?:[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]?,?([0-9]{1,3})[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]?,?(?:[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]?,?([0-9]{1,3})[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]?,?))(?:[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]?,?([0-9]{1,3})[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]?,??)\)$/i, {
  red: 1,
  green: 2,
  blue: 3
});
export var HEX_REGEXP = /^#?(?:[0-9a-fA-F]{3}){1,2}$/i;
export function colorToRGBA(color, alpha) {
  if (alpha === void 0) {
    alpha = 1;
  }

  if (color === undefined) return;
  if (color === null) return;

  if (RGBA_REGEXP.test(color)) {
    var groups = color.match(RGBA_REGEXP).groups;
    if (!groups) return;
    return "rgba(" + groups.red + "," + groups.green + "," + groups.blue + "," + alpha + ")";
  } else if (RGB_REGEXP.test(color)) {
    return rgbToRgba(color, alpha);
  } else if (HEX_REGEXP.test(color)) {
    var hex = intToHex(color);
    if (!hex) return;
    var rgb = hexToRgb(hex);
    if (!rgb) return;
    return "rgba(" + rgb.red + "," + rgb.green + "," + rgb.blue + "," + alpha + ")";
  } else {
    var _hex = intToHex(color);

    if (!_hex) return;

    var _rgb = hexToRgb(_hex);

    if (!_rgb) return;
    return "rgba(" + _rgb.red + "," + _rgb.green + "," + _rgb.blue + "," + alpha + ")";
  }
}
export function rgbToRgba(color, alpha) {
  if (alpha === void 0) {
    alpha = 1;
  }

  if (!RGB_REGEXP.test(color)) {
    return;
  }

  if (alpha === undefined || alpha === null) {
    alpha = 1;
  }

  var groups = color.match(RGB_REGEXP).groups;
  return "rgba(" + groups.red + "," + groups.green + "," + groups.blue + "," + alpha + ")";
}
export function intToHex(_int) {
  if (_int === null || _int === undefined) {
    return null;
  }

  if (HEX_REGEXP.test(_int)) {
    _int = _int.toString(16);

    if (_int.charAt(0) !== '#') {
      _int = ("000000" + _int).slice(-6);
      return "#" + _int;
    }

    return _int;
  }

  if (Number.isNaN(Number(_int))) {
    return null;
  }

  _int = "000000" + _int.toString(16);
  return "#" + _int.slice(-6);
}
/**
 * Returns an object of 3 numbers representing the red, green, and blue values
 * of the given hex. If the hex number can't be parse, undefined is returned.
 * Got some help from http://stackoverflow.com/a/6444043/703108
 */

export function hexToRgb(hex) {
  if (typeof hex !== 'string') {
    return null;
  } // strip the leading # if it's there


  hex = hex.replace(/^#/, '');

  if (hex.length === 3) {
    hex = hex.replace(/(.)/g, '$1$1');
  }

  if (hex.length === 6) {
    return {
      red: parseInt(hex.substr(0, 2), 16),
      green: parseInt(hex.substr(2, 2), 16),
      blue: parseInt(hex.substr(4, 2), 16)
    };
  } else {
    return null;
  }
}
/*
 * @namespace Util
 * @mixin
 */

var Color = {
  RGBA_REGEXP: RGBA_REGEXP,
  RGB_REGEXP: RGB_REGEXP,
  HEX_REGEXP: HEX_REGEXP,
  colorToRGBA: colorToRGBA,
  rgbToRgba: rgbToRgba,
  intToHex: intToHex,
  hexToRgb: hexToRgb,
  // Return the fgColor that has the highest contrast with the background color
  bestContrast: function bestContrast(bgColor) {
    for (var _len = arguments.length, fgColors = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      fgColors[_key - 1] = arguments[_key];
    }

    var best = _(fgColors).max(function (fgColor) {
      return Color.contrast(bgColor, fgColor);
    }); // Compensate for Underscore.js stupidity.


    if (best === -Infinity) {
      return undefined;
    } else {
      return best;
    }
  },

  /*
   * http://juicystudio.com/article/luminositycontrastratioalgorithm.php
   * (L1+.05) / (L2+.05)
   * L1 is the higher value (of text or background) and L2 is the lower value.
   * the 0.05 offset is included to compensate for contrast ratios that occur when a value is at or near zero, and for ambient light effects.
   * Accepts a hex string or an object with `red`, `green`, and `blue` properties.
   */
  contrast: function contrast(c1, c2) {
    var l1 = Color.luminosity(c1);
    var l2 = Color.luminosity(c2);

    if (l1 == null || l2 == null) {
      return;
    }

    if (l1 > l2) {
      return (l1 + 0.05) / (l2 + 0.05);
    } else {
      return (l2 + 0.05) / (l1 + 0.05);
    }
  },

  /*
   * http://juicystudio.com/article/luminositycontrastratioalgorithm.php
   * .2126*R + .7152*G + .0722B using linearised R, G, and B values.
   * Accepts an rgb(a) string, a hex string, or an object
   * with `red`, `green`, and `blue` properties.
   */
  luminosity: function luminosity(color) {
    var rgb = {};

    if (color === null || color === undefined) {
      color = {};
    }

    if (color.red != null && color.green != null && color.blue != null) {
      rgb = color;
    } else if (RGBA_REGEXP.test(color)) {
      var groups = color.match(RGBA_REGEXP).groups;

      if (groups) {
        rgb = {
          red: groups.red,
          green: groups.green,
          blue: groups.blue
        };
      }
    } else if (RGB_REGEXP.test(color)) {
      var _groups2 = color.match(RGB_REGEXP).groups;

      if (_groups2) {
        rgb = {
          red: _groups2.red,
          green: _groups2.green,
          blue: _groups2.blue
        };
      }
    } else {
      // Assume hex
      rgb = Color.hexToRgb(color);
    }

    if (rgb) {
      var _rgb2 = rgb,
          red = _rgb2.red,
          green = _rgb2.green,
          blue = _rgb2.blue;
      red = Color.linearise(red);
      green = Color.linearise(green);
      blue = Color.linearise(blue);
      return 0.2126 * red + 0.7152 * green + 0.0722 * blue;
    }
  },

  /*
   * http://juicystudio.com/article/luminositycontrastratioalgorithm.php
   * Linearised R (for example) = (R/FS)^2.2 where FS is full scale value (255 for 8 bit color channels).
   */
  linearise: function linearise(channel, fullScale) {
    if (fullScale == null) {
      fullScale = 255;
    }

    return Math.pow(channel / fullScale, 2.2);
  }
};
export default Color;